import { registerMutation } from 'data-fetching-client';
import { upsertRouting } from 'FormsUI/api/Routing';
import { GET_FORM_ROUTING_FIELD_NAME } from '../queries/getFormRouting';
export const UPSERT_ROUTING = registerMutation({
  fieldName: GET_FORM_ROUTING_FIELD_NAME,
  args: ['formRouting'],
  fetcher: upsertRouting
});